import { Zones } from "@/models/database/zones/Zones.model";
import { create } from "zustand";

interface ZonesState {
  zones: Zones[] | null;
  loading: boolean;
  error: Error | null;
  setZones: (zones: Zones[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  getZoneBySlug: (slug: string) => Zones | undefined;
  addZone: (zoneItem: any) => void;
}

export const useZonesStore = create<ZonesState>((set, get) => ({
  zones: null,
  loading: true,
  error: null,
  setZones: (zones) => set({ zones }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  getZoneBySlug: (slug) => {
    const { zones } = get();
    return zones?.find((item) => item.slug === slug);
  },
  addZone: (zoneItem) => {
    const { zones } = get();
    set({ zones: zones ? [...zones, zoneItem] : [zoneItem] });
  },
}));
